/* <template>
  <b-overlay :show="show" rounded="md" :shown="shown()">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #fef0f4" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>

      <b-row
        align-h="center"
        style="width: 100%; margin-top: 60px; background-color: #fef0f4"
        class="reduced-margin-top"
      >
        <b-col
          cols="12"
          style="padding-top: 5px"
          class="pl-0 pr-0 cart-nav-bundle"
        >
          <b-row style="">
            <b-col
              class="pl-pr-0-sm pb-5"
              cols="12"
              style="
                background-color: #fef0f4;
                padding-left: 5%;
                padding-right: 5%;
              "
            >
              <b-row class="pt-5" data-aos="fade-right" data-aos-delay="250" v-if='stage==0'>
                <b-col
                  class="hero-text-sm"
                  style="
                    color: #f06595;
                    font-weight: 700;
                    max-width: 1080px;
                    margin: 0 auto;
                    font-size: 24px;
                  "
                >
                  New, Pay-as-you-Go Plan
                </b-col>
              </b-row>
              <b-row class="pt-2" v-if='stage==0'>
                <b-col
                  style="
                    font-size: 16px;
                    color: #45484b;
                    max-width: 1080px;
                    margin: 0 auto;
                  "
                >
                  Flexible monthly plans that are right for your family.
                </b-col>
              </b-row>

              <b-row class="pb-5 pl-3 pr-3 subscription" v-if="stage == 0">
                <b-col
                  cols="12"
                  class="pt-4 pb-4 pl-0 pr-0"
                  v-for="(item, index) in inventory_pro"
                  :key="index"
                  style="max-width: 1080px; margin: 0 auto"
                >
                  <b-row>
                    <b-col style="background-color: white; border-radius: 10px">
                      <b-row class="pt-2 pb-2">
                        <b-col
                          class="bundle-h1 align-center-small hide-when-small"
                        >
                          <span style="color: #2f95eb">Sign</span> +
                          <span style="color: #fb870c">Up</span> +
                          <span style="color: #00bea4">Today</span>
                        </b-col>
                      </b-row>
                      <b-row class="hide-when-small" hidden>
                        <b-col
                          class="pt-2 pb-3 align-center-small"
                          style="font-size: 15px"
                        >
                          {{ inventory_pro[index].h1 }}
                        </b-col>
                      </b-row>
                      <b-row class="pb-5">
                        <b-col md="6" cols="12" class="hide-when-small">
                          <b-row>
                            <b-col>
                              <b-img
                                center
                                class="image_bundle"
                                fluid
                                :src="getImage2(item)"
                              ></b-img>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 21px;
                                text-align: center;
                              "
                            >
                              What's included in my plan?
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 0) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 1) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 2) }}<sup>1</sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 3) }}<sup>2</sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 4) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 5) }}
                            </b-col>
                          </b-row>

                          <b-row v-if="adaptor == 1 && index < 2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (US/CA/MX)
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 2 && index < 2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (AU/NZ)
                            </b-col>
                          </b-row>
                          <b-row class="pt-2" hidden>
                            <b-col
                              cols="8"
                              style="
                                color: #323436;
                                font-size: 12px;
                                text-align: center;
                                margin: 0 auto;
                              "
                            >
                              {{ getH4(item) }}
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col md="6" cols="12" class="pl-0 pr-0">
                          <b-row v-if="item.list.length > 1" class="pt-2">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436"> How many </span>
                              <span style="color: #00bea4" class="pl-2 pr-2"
                                >Pro Trackers</span
                              >
                              <span style="color: #323436"> do you need? </span>
                              <span
                                style="color: #2f95eb; padding-left: 7px"
                                hidden
                                v-if="index == 0"
                              >
                                Pro Trackers
                              </span>
                              <span
                                style="color: #2f95eb; padding-left: 7px"
                                hidden
                                v-if="index == 1"
                              >
                                Classic Trackers
                              </span>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="color: #1f2122; font-size: 14px"
                              class="pl-0 pr-0"
                              v-if="inventory_pro[index].index1 == 0"
                            >
                              {{ inventory_pro[index].index1 + 1 }} Pro Tracker
                              - Ready for
                              {{ inventory_pro[index].index1 + 1 }} user
                            </b-col>
                            <b-col
                              style="color: #1f2122; font-size: 14px"
                              class="pl-0 pr-0"
                              v-else
                            >
                              {{ inventory_pro[index].index1 + 1 }} Pro Trackers
                              - Ready for
                              {{ inventory_pro[index].index1 + 1 }} users
                            </b-col>
                          </b-row>

                          <b-row v-if="item.list.length > 1">
                            <b-col
                              style=""
                              md="3"
                              cols="12"
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in item.list"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.tracker_size_img"
                                style="cursor: pointer"
                                :class="{
                                  'selected-border': index2 == item.index1,
                                }"
                                class="unselected-border"
                                @click="select_bundle_size(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-3">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436"> Select </span>
                              <span
                                style="color: #fb870c"
                                class="pl-2 pr-2"
                                v-if="index == 0"
                                >Skin</span
                              >
                              <span
                                style="color: #fb870c"
                                class="pl-2 pr-2"
                                v-else
                                >Design</span
                              >
                              <span style="color: #323436" class="pr-2">
                                options
                              </span>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              md="3"
                              cols="12"
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in item.list[item.index1]
                                .skus"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.tracker_skin_img"
                                style="cursor: pointer"
                                class="unselected-border"
                                :class="{
                                  'selected-border': index2 == item.index2,
                                }"
                                @click="select_bundle_design(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-4" v-if="index != 2">
                            <b-col
                              cols="12"
                              style="display: contents"
                              class="bundle-h2"
                            >
                              <span style="color: #323436"> Select </span>
                              <span style="color: #00bea4" class="pl-2 pr-2"
                                >Hub</span
                              >
                              <span style="color: #323436" class="pr-2">
                                options
                              </span>
                            </b-col>
                          </b-row>
                          <b-row v-if="index != 2" class="pb-2">
                            <b-col
                              class="pl-0 pr-0"
                              style="max-width: 500px"
                              v-if="adaptor == 0"
                            >
                              1 Truthbrush Hub is included free. No power
                              adaptor.
                            </b-col>
                            <b-col
                              class="pl-0 pr-0"
                              style="max-width: 500px"
                              v-if="adaptor == 1"
                            >
                              1 Truthbrush Hub + 1 Type-A Adaptor for wall
                              outlet (US, Canada, Mexico)
                            </b-col>
                            <b-col
                              class="pl-0 pr-0"
                              style="max-width: 500px"
                              v-if="adaptor == 2"
                            >
                              1 Truthbrush Hub + 1 Type-I Adaptor for wall
                              outlet (Australia)
                            </b-col>
                          </b-row>
                          <b-row v-if="index != 2">
                            <b-col
                              md="3"
                              cols="12"
                              class="pt-2 bundle-cell"
                              v-for="(item2, index2) in hub_type"
                              :key="index2"
                            >
                              <b-img
                                fluid
                                center
                                :src="item2.image"
                                style="cursor: pointer"
                                class="unselected-border"
                                :class="{
                                  'selected-border': index2 == adaptor,
                                }"
                                @click="select_bundle_hub(item, index2)"
                              ></b-img>
                            </b-col>
                          </b-row>

                          <b-row class="pt-2">
                            <hr style="width: 100%; height: 1px" />
                          </b-row>
                          <b-row
                            v-if="
                              getCoupon() == 'babysideburns' ||
                              getCoupon() == 'A3KzVdj8'
                            "
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Baby Sideburns Sale!
                            </b-col>
                          </b-row>

                          <b-row
                            v-if="getCoupon() == '5minutesformom'"
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              5 Minutes for Mom Special Price!
                            </b-col>
                          </b-row>
                          <b-row v-if="getCoupon() == 'Sixfr2n3'" class="pb-2">
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Black Friday Sale - Extra 15% Off
                            </b-col>
                          </b-row>

                          <b-row
                            v-if="getCoupon() == 'mylifesuckers'"
                            class="pb-2"
                          >
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              MyLifeSuckers - Extra 10% Off
                            </b-col>
                          </b-row>

                          <b-row v-if="getCoupon() == 'TDm1cVpj'" class="pb-2">
                            <b-col
                              class="pl-0 pt-1 pb-1"
                              style="
                                color: white;
                                background-color: #d9735c;
                                text-align: center;
                              "
                            >
                              Holiday Sales! - Extra 10% Off
                            </b-col>
                          </b-row>

                          <b-row v-if="calculateFinalPrice(100) == 100">
                            <b-col
                              style="color: #1f2122"
                              class="align-center-small pl-0 pr-0"
                            >
                              <b style="font-size: 25px"
                                >${{ getPrice(index, 1) }}&nbsp;</b
                              >
                              due today
                               <b style='margin-left:3px;margin-right:3px'>+</b> <b style="font-size: 25px"
                                >${{calc_month_fee(inventory_pro[index].index1, inventory_pro[index].index2)}}</b> /mo/user
                            </b-col>
                          </b-row>

                          <b-row v-else>
                            <b-col
                              style="color: #1f2122;"
                              class="align-center-small pl-0 pr-0"
                            >
                              <b style="font-size: 25px"
                                >${{
                                  calculateFinalPrice(getPrice(index, 1))
                                }}&nbsp;</b
                              >
                              <s>${{ getPrice(index, 1) }}</s> due today
                              <b style='margin-left:3px;margin-right:3px'>+</b> <b style="font-size: 25px">${{calc_month_fee(inventory_pro[index].index1, inventory_pro[index].index2)}}</b> /mo/user
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="color: #1f2122;"
                              class="align-center-small pl-0 pr-0"
                            >
                              Free Tracker every 24 mo. Cancel anytime.
                            </b-col>
                          </b-row>
                          <b-row
                            class="pt-3 pb-1 pl-0 reduced_pl_pr"
                            style="cursor: pointer"
                            @click="gotoT4()"
                            v-if="index != 2"
                            hidden
                          >
                            <b-col
                              style="background-color: #e7f8fd"
                              class="pt-3 pb-3"
                            >
                              <b-row>
                                <b-col
                                  cols="2"
                                  class="reduced_pl_pr"
                                  align-self="center"
                                >
                                  <b-img
                                    src="img/logo-pay-full.png"
                                    style="max-width: 40px"
                                    fluid
                                  ></b-img>
                                </b-col>
                                <b-col cols="10" class="pl-1 pr-0">
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-1"
                                  >
                                    <b-col cols="pl-0 pr-0">
                                      <b style="font-size: 14px">
                                        Looking for unlimited version?</b
                                      >
                                    </b-col>
                                  </b-row>
                                  <b-row
                                    style="justify-content: left"
                                    class="pt-0"
                                  >
                                    <b-col
                                      cols="pl-0 pr-0"
                                      style="max-width: 380px"
                                    >
                                      Pay in full and save on unlimited service
                                      bundles.
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col cols="12" class="pl-0 pr-0 pt-3">
                              <b-button
                                pill
                                class="blue-button max-width-sm"
                                style="width: 100%; height: 40px"
                                v-on:click="
                                  onAddCart2(
                                    item,
                                    item.index1,
                                    item.index2,
                                    item.index3
                                  )
                                "
                              >
                                <span style="font-size: 18px">Add to Cart</span>
                              </b-button>
                            </b-col>
                          </b-row>

                          <b-row class="pt-3 hide-when-small">
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                              v-if="index == 2"
                            >
                              Free US Shipping ($50 or above) | Ship Worldwide
                            </b-col>
                            <b-col
                              style="color: #323436; font-size: 14px"
                              class="pl-0 pr-0"
                              v-else
                            >
                             Ships today | Worldwide shipping
                            </b-col>
                          </b-row>
                          <b-row class="pt-0 hide-when-small">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: left;
                              "
                              class="pl-0 pr-0"
                            >
                              Works with manual and electric toothbrushes
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col
                          md="6"
                          cols="12"
                          class="pl-pr-0-sm pt-3 hide-when-big"
                        >
                          <b-row class="pt-2">
                            <b-col>
                              <b-img
                                center
                                class="image_bundle"
                                fluid
                                :src="getImage2(item)"
                              ></b-img>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 21px;
                                text-align: center;
                              "
                            >
                              What's included in my plan?
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 0) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 1) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 2) }}<sup>1</sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 3) }}<sup>2</sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 4) }}
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              {{ getH3(item, 5) }}
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 1 && index < 2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (US/CA/MX)
                            </b-col>
                          </b-row>
                          <b-row v-if="adaptor == 2 && index < 2">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 17px;
                                text-align: center;
                              "
                            >
                              1 Power Adaptor (AU/NZ)
                            </b-col>
                          </b-row>
                          <b-row class="pt-2" hidden>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 12px;
                                text-align: center;
                                margin: 0 auto;
                                max-width: 340px;
                              "
                              >what's in
                              {{ getH4(item) }}
                            </b-col>
                          </b-row>
                          <b-row class="pt-3 hide-when-big">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="pl-0 pr-0"
                              v-if="index == 2"
                            >
                              Free US Shipping Above $50 | Ship Worldwide
                            </b-col>
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="pl-0 pr-0"
                              v-else
                            >
                              Ships today | Worldwide shipping
                            </b-col>
                          </b-row>
                          <b-row class="pt-0 hide-when-big">
                            <b-col
                              style="
                                color: #323436;
                                font-size: 14px;
                                text-align: center;
                              "
                              class="pl-0 pr-0"
                            >
                              Works with manual and electric toothbrushes
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>

                      <b-row class="justify-content-center pt-5">
                        <h1
                          style="max-width: 100%; text-align: center"
                          class="h1-font"
                        >
                          Frequently Asked Questions
                        </h1>
                      </b-row>
                      <b-row class="pl-5 pr-5 pl_pr_0_sm">
                        <VueFaqAccordion
                          :items="myItems"
                          :activeColor="activeColorAccordian"
                          :borderColor="borderColorAccordian"
                        />
                      </b-row>
                      <b-row style="justify-content: center" class="pt-5 pb-5">
                        <a href="/#/faq">Visit our FAQ section</a>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row
                    align-h="center"
                    style="width: 100%; margin-top: 40px; margin-bottom: 60px"
                  >
                    <b-col
                      cols="12"
                      style="padding-top: 5px"
                      class="pl-0 pr-0 cart-nav"
                    >
                      <ol
                        style="
                          color: #4f4f4f;
                          font-size: 10px;
                          padding-left: 15px;
                        "
                      >
                        <li style="font-size: 10px">
                          Unlimited access to Truthbrush app and tracking with active account in good standing. Trackers and Hubs
                          are locked to your email account and not transferrable
                          to another account.
                        </li>
                        <li style="font-size: 10px">
                          Each user in your plan will receive a new Pro Tracker every 24 months
                          with an active account in good standing.
                        </li>
                        
                      </ol>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pb-5 pt-3 pl-3 pr-3 subscription" v-if="stage == 1">
                <b-col
                  cols="12"
                  class="pt-4 pb-4 pl-0 pr-0"
                  style="max-width: 1080px; margin: 0 auto"
                >
                  <b-row>
                    <b-col style="background-color: white; border-radius: 10px">
                      <b-row class="pt-4 pb-2">
                        <b-col class="bundle-h1 align-center-small">
                          <span style="color: #2f95eb">Truthbrush</span> +
                          <span style="color: #fb870c">Skins</span> 
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col
                          class="pt-2 pb-3 align-center-small"
                          style="font-size: 15px"
                        >
                          Add more fun to your brushing with colorful Truthbrush
                          skins! Decorative skins are optional and cost extra.
                        </b-col>
                      </b-row>

                      <b-row
                        class="pl-3 pr-3 pt-5 reduced_pl_pr no-max-width-small"
                      >
                        <b-col
                          class="pb-4 pl-2 pr-2"
                          lg="2"
                          md="3"
                          cols="4"
                          v-for="(item, index) in getskinskulist()"
                          :key="index"
                          @click="clickskin(index)"
                        >
                          <b-img
                            :src="item.images[1]"
                            fluid
                            center
                            :class="{ activeskuskin: getselectedskin(index) }"
                            class="swatch-thumbnail-t6"
                          ></b-img>
                          <div
                            style="
                              position: absolute;
                              top: 0;
                              right: 5%;
                              width: 15%;
                            "
                            v-if="skinarray[index] == 1"
                          >
                            <b-img src="img/Close.png" fluid></b-img>
                          </div>
                        </b-col>
                      </b-row>

                      <b-row class="pt-2">
                        <hr style="width: 100%; height: 1px" />
                      </b-row>

                      <b-row>
                        <b-col
                          style="color: #1f2122; text-align: center"
                          class="align-center-small pl-0 pr-0"
                        >
                          <b
                            style="font-size: 27px"
                            v-if="getTotalNumSkin() <= 1"
                            >{{ getTotalNumSkin() }} Skin Added</b
                          >
                          <b style="font-size: 27px" v-else
                            >{{ getTotalNumSkin() }} Skins Added</b
                          >

                          <span style="font-size: 27px; padding-left: 20px"
                            >${{ getTotalPriceSkin().toFixed(2) }}</span
                          >
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col
                          cols="12"
                          class="pl-0 pr-0 pt-3"
                          style="text-align: center"
                        >
                          <b-button
                            pill
                            class="blue-button max-width-sm"
                            style="max-width: 100%; height: 40px; width: 500px"
                            v-on:click="onAddCart()"
                          >
                            <span style="font-size: 18px"
                              >Continue to Checkout</span
                            >
                          </b-button>
                        </b-col>
                      </b-row>

                      <b-row class="pt-3" style="text-align: center">
                        <b-col
                          style="color: #323436; font-size: 14px"
                          class="pl-0 pr-0"
                        >
                          Ships today | Worldwide shipping
                        </b-col>
                      </b-row>
                      <b-row class="pt-0 pb-5" style="text-align: center">
                        <b-col
                          style="color: #323436; font-size: 14px"
                          class="pl-0 pr-0"
                        >
                          Factory warranty | 30d return policy
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>

      <b-row>
        <Checkout-Express id="my-modal" ref="my-modal"> </Checkout-Express>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import CheckoutExpress from "./../components/CheckoutExpress";
import VueFaqAccordion from "vue-faq-accordion";
import storage from "../storage";
import store from "../store";
import env from "../env";
export default {
  name: "Bundle",
  components: {
    NavHeader,
    NavFooter,
    CheckoutExpress,
    VueFaqAccordion,
  },
  data() {
    return {
      show: false,
      adaptor: 0,
      activeColorAccordian: "#000000",
      borderColorAccordian: "#d9dadb",
      skinarray: [],
      stage: 1,
      hub_type: [
        {
          image: "/img/products/travel_hub.png",
        },

        {
          image: "/img/products/hub_adaptor_type_1.png",
        },

        {
          image: "/img/products/hub_adaptor_type_i.png",
        },
      ],
      myItems: [
        {
          title:
            '1. What\'s the difference between the "Pay in full" and the “Pay-as-you-Go” options?',
          value: "The \"Pay in full\" option allows unlimited use of your Truthbrush tracker and app with no further fee; the \"Pay-as-you-Go\" allows users to get started with just a small activation fee. Users then pay a monthly fee to maintain the service. Users may cancel at any time. \"Pay-as-you-Go\" plan users get new, free trackers every 24 months."
            },

        {
          title:
            "2. How much does the Truthbrush “Pay-as-you-Go” Service cost?",
          value:
            "Each service plan comes with an up-front activation cost which depends on how many trackers in the plan. After that as low as 99&#162;/mo/user plus tax.",
        },
        {
          title:
            "3. When does my included complimentary 2 weeks start and end?",
          value:
            "The complimentary 2 weeks of Truthbrush “Pay-as-you-Go” Service begins at purchase, and continues for 14 days from that date. Once started, the complimentary 2 weeks cannot be paused or restarted.",
        },
        {
          title: "4. When is my billing cycle?",
          value:
            "Truthbrush “Pay-as-you-Go” Service starts on the date of purchase. You will be billed for your first payment once the free 2 weeks has ended. Your account will be auto-billed every month after that point. You can check details of your payments through the Truthbrush app.",
        },
        {
          title: "5. How can I cancel the Truthbrush “Pay-as-you-Go” plan?",
          value: "To cancel your Truthbrush “Pay-as-you-Go” plan, simply open the Truthbrush app, goto “Settings” and then click on “Manage Subscription”. The cancellation will take effect the day after the last day of the current subscription period. You do NOT need to send back your Truthbrush Tracker and Hub. They will be automatically disabled from our system."
        },
        {
          title: "6. How do I request my free, new tracker every 24 months?",
          value: "Each user in your Pay-as-you-Go plan will receive a free, new Pro Tracker every 24 months, automatically shipped to you. The new trackers will be linked with your service plan, and your old trackers will cease to work 2 weeks after the new trackers are activated."
        },

        {
          title: '7. How long is my warranty for "Pay-as-you-Go" plan?',
          value:
            "Your Truthbrush trackers are covered under the extended, worry-free warranty for manufacturing defects as long as you maintain a paid plan. For details, please visit https://www.truthbrush.com/#/warranty",
        },
      ],
      inventory_pro: [
        {
          h1: "Includes the new (2023 model year) Pro Trackers (battery replaceable) and 1 data collection Hub. Each bundle is ready to use with your plan.",
          index1: 0,
          index2: 0,
          index3: 0,
          list: [
            {
              h2: "Truthbrush Pay-as-you-Go plan with 1 Pro Tracker",
              tracker_size_img: "/img/products/bundle_pro_1.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_1_bundle",
                      base_price: 44.98,
                      list_price: 9.98,
                      h3: "1 Pro Tracker + 1 Hub | No Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months  | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/1_pro_0b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Astronaut.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_1_bundle_skin_opt_1",
                      base_price: 44.98,
                      list_price: 9.98,
                      h3: "1 Pro Tracker + 1 Hub |  Astronaut Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months  | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/1_pro_1b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Flamingo.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_1_bundle_skin_opt_2",
                      base_price: 44.98,
                      list_price: 9.98,
                      h3: "1 Pro Tracker + 1 Hub | Flamingo Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months  | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/1_pro_2b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Heart.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_1_bundle_skin_opt_3",
                      base_price: 44.98,
                      list_price: 9.98,
                      h3: "1 Pro Tracker + 1 Hub | Heart Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months  | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/1_pro_3b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Orange.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_1_bundle_skin_opt_4",
                      base_price: 44.98,
                      list_price: 9.98,
                      h3: "1 Pro Tracker + 1 Hub | Orange Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months  | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/1_pro_4b.png",
                    },
                  ],
                },
              ],
            },
            {
              h2: "2 Pro Tracker Plan Activation",
              tracker_size_img: "/img/products/bundle_pro_2.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_2_bundle",
                      base_price: 69.99,
                      list_price: 14.97,
                      h3: "2 Pro Trackers + 1 Hub | No Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/2_pro_0b.png",
                    },
                  ],
                },


                {
                  tracker_skin_img: "/img/products/Dinosaur_Unicorn.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_2_bundle_skin_opt_1",
                      base_price: 69.99,
                      list_price: 14.97,
                      h3: "2 Pro Trackers + 1 Hub | 2 Skins (Dinosaur, Unicorn) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/2_pro_1b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Astronaut_Flamingo.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_2_bundle_skin_opt_2",
                      base_price: 69.99,
                      list_price: 14.97,
                      h3: "2 Pro Trackers + 1 Hub | 2 Skins (Astronaut, Flamingo) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/2_pro_2b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Monster_Truck_Foxcream.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_2_bundle_skin_opt_3",
                      base_price: 69.99,
                      list_price: 14.97,
                      h3: "2 Pro Trackers + 1 Hub | 2 Skins (Monster Truck, Foxcream) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/2_pro_3b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Panda_Peacock.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_2_bundle_skin_opt_4",
                      base_price: 69.99,
                      list_price: 14.97,
                      h3: "2 Pro Trackers + 1 Hub | 2 Skins (Panda, Peacock) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/2_pro_4b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Orca_Heart.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_2_bundle_skin_opt_5",
                      base_price: 69.99,
                      list_price: 14.97,
                      h3: "2 Pro Trackers + 1 Hub | 2 Skins (Orca, Heart) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/2_pro_5b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Mermaid_Daisy.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_2_bundle_skin_opt_6",
                      base_price: 69.99,
                      list_price: 14.97,
                      h3: "2 Pro Trackers + 1 Hub | 2 Skins (Mermaid, Daisy) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/2_pro_6b.png",
                    },
                  ],
                },
              ],
            },
            {
              h2: "3 Pro Tracker Plan Activation",
              tracker_size_img: "/img/products/bundle_pro_3.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_3_bundle",
                      base_price: 89.99,
                      list_price: 19.96,
                      h3: "3 Pro Trackers + 1 Hub | No Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/3_pro_bundle_no_skin.png",
                    },
                  ],
                },



                {
                  tracker_skin_img: "/img/products/USA_Flag_Monster_Truck_Baseball_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_3_bundle_skin_opt_1",
                      base_price: 89.99,
                      list_price: 19.96,
                      h3: "3 Pro Trackers + 1 Hub | 3 Skins (Flag, Monster Truck, Baseball) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/3_pro_2b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Dinosaur_Football_Heart_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_3_bundle_skin_opt_2",
                      base_price: 89.99,
                      list_price: 19.96,
                      h3: "3 Pro Trackers + 1 Hub | 3 Skins (Dinosaur, Football, Heart) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/3_pro_3b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Unicorn_Flamingo_Orange_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_3_bundle_skin_opt_3",
                      base_price: 89.99,
                      list_price: 19.96,
                      h3: "3 Pro Trackers + 1 Hub | 3 Skins (Unicorn, Flamingo, Orange) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/3_pro_4b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Monster_Truck_Unicorn_Penguin_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_3_bundle_skin_opt_4",
                      base_price: 89.99,
                      list_price: 19.96,
                      h3: "3 Pro Trackers + 1 Hub | 3 Skins (Monster Truck, Unicorn, Penguin) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/3_pro_5b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Owl_Axo_Astronaut.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_3_bundle_skin_opt_5",
                      base_price: 89.99,
                      list_price: 19.96,
                      h3: "3 Pro Trackers + 1 Hub | 3 Skins (Snowy Owl, Axolotl, Astronaut) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/3_pro_6b.png",
                    },
                  ],
                },
              ],
            },


            {
              h2: "4 Pro Tracker Plan Activation",
              tracker_size_img: "/img/products/bundle_pro_4.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_4_bundle",
                      base_price: 109.99,
                      list_price: 24.95,
                      h3: "4 Pro Trackers + 1 Hub | No Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/4_pro_bundle_no_skin.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/Surfing_Football_USA_Flag_Panda_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_4_bundle_skin_opt_1",
                      base_price: 109.99,
                      list_price: 24.95,
                      h3: "4 Pro Trackers + 1 Hub | 4 Skins (Surfing, Football, Flag, Panda) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/4_pro_2b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Astronaut_Unicorn_Baseball_Peacock_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_4_bundle_skin_opt_2",
                      base_price: 109.99,
                      list_price: 24.95,
                      h3: "4 Pro Trackers + 1 Hub | 4 Skins (Astronaut, Unicorn, Baseball, Peacock) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/4_pro_3b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Dinosaur_Flamingo_Orange_Heart_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_4_bundle_skin_opt_3",
                      base_price: 109.99,
                      list_price: 24.95,
                      h3: "4 Pro Trackers + 1 Hub | 4 Skins (Dinosaur, Flamingo, Orange, Heart) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/4_pro_4b.png",
                    },
                  ],
                },
                {
                  tracker_skin_img: "/img/products/Griffin_MonkeyKing_Bunny_Foxcream.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_4_bundle_skin_opt_4",
                      base_price: 109.99,
                      list_price: 24.95,
                      h3: "4 Pro Trackers + 1 Hub | 4 Skins (Griffin, Monkey King, Bunny, Foxcream) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/4_pro_5b.png",
                    },
                  ],
                },
              ],
            },

            {
              h2: "5 Pro Tracker Plan Activation",
              tracker_size_img: "/img/products/bundle_pro_5.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_5_bundle",
                      base_price: 129.99,
                      list_price: 29.94,
                      h3: "5 Pro Trackers + 1 Hub | No Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/5_pro_1b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/5_random_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_5_bundle_skin_opt_1",
                      base_price: 129.99,
                      list_price: 29.94,
                      h3: "5 Pro Trackers + 1 Hub | Assorted Skins (Random) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/5_pro_2b.png",
                    },
                  ],
                },
              ],
            },
            {
              h2: "6 Pro Tracker Plan Activation",
              tracker_size_img: "/img/products/bundle_pro_6.png",
              skus: [
                {
                  tracker_skin_img: "/img/products/no_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_6_bundle",
                      base_price: 129.99,
                      list_price: 34.93,
                      h3: "6 Pro Trackers + 1 Hub | No Skin | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/6_pro_1b.png",
                    },
                  ],
                },

                {
                  tracker_skin_img: "/img/products/6_random_skin.png",
                  opt: [
                    {
                      skuid: "sku_activation_pro_6_bundle_skin_opt_1",
                      base_price: 129.99,
                      list_price: 34.93,
                      h3: "6 Pro Trackers + 1 Hub | Assorted Skins (Random) | Unlimited access to Truthbrush app | New Pro Tracker every 24 months | Worry-free, extended warranty | 2 weeks free trial",
                      image: "/img/products/6_pro_2b.png",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {},
  methods: {
    calc_month_fee(k, skin){
      if(skin>0){
        //has skin
        if(k==0){
          return "2.24"
        }else if(k==1){
          return "1.75"
        }else if(k==2){
          return "1.50"
        }else if(k==3){
          return "1.35"
        }else if(k==4){
          return "1.25"
        }else if(k==5){
          return "1.19"
        }else{
          return "1.19"
        }
      }else{
        //no skin
        if(k==0){
          return "1.99"
        }else if(k==1){
          return "1.49"
        }else if(k==2){
          return "1.25"
        }else if(k==3){
          return "1.15"
        }else if(k==4){
          return "1.07"
        }else if(k==5){
          return "0.99"
        }else{
          return "0.99"
        }
      }
    },
    gotoT4() {
      window.location.href = "/#/select_t4";
    },
    getTotalPriceSkin() {
      var sum = 0;
      for (var i = 0; i < this.skinarray.length; i++) {
        sum += store.state.skinskulist[i].price * this.skinarray[i];
      }
      return sum / 100.0;
    },
    getTotalNumSkin() {
      var sum = 0;
      for (var i = 0; i < this.skinarray.length; i++) {
        sum += this.skinarray[i];
      }
      return sum;
    },
    getselectedskin(index) {
      return this.skinarray[index] == 1;
    },
    clickskin(index) {
      if (this.skinarray[index] == 1) {
        this.skinarray[index] = 0;
      } else {
        this.skinarray[index] = 1;
      }
      var arr = [];
      for (var i = 0; i < this.skinarray.length; i++) {
        arr.push(this.skinarray[i]);
      }
      this.skinarray = arr;
    },
    shuffleArray(array) {
      for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
    },
    getskinskulist() {
      return store.state.skinskulist;
    },
    select_bundle_size(item, index2) {
      item.index1 = index2;
      item.index2 = 0;
      item.index3 = 0;
    },
    select_bundle_design(item, index) {
      item.index2 = index;
    },
    select_bundle_hub(item, index) {
      //item.index3 = index;
      this.adaptor = index;
    },
    getSelectHubClass(item, index) {
      if (item.index3 == index) {
        return "product-select-box2";
      }
      return "product-select-box";
    },
    clicksku_hub(item, index) {
      item.index3 = index;
    },
    getImage(item) {
      return item.list[item.index].image;
    },
    getImage2(item) {
      return item.list[item.index1].skus[item.index2].opt[item.index3].image;
    },
    getImage3(item, index) {
      return item.opt[index].image;
    },
    getPrice(index, mode) {
      var index1 = this.inventory_pro[index].index1;
      var index2 = this.inventory_pro[index].index2;
      var index3 = this.inventory_pro[index].index3;

      var adaptorloading = 0;
      if (this.adaptor > 0) {
        adaptorloading = 4.99;
      }

      if (mode == 0) {
        return (
          this.inventory_pro[index].list[index1].skus[index2].opt[index3]
            .base_price + adaptorloading
        ).toFixed(2);
      } else if (mode == 1) {
        return (
          this.inventory_pro[index].list[index1].skus[index2].opt[index3]
            .list_price + adaptorloading
        ).toFixed(2);
      }
    },

    getPriceNoAdaptor(index, mode) {
      var index1 = this.inventory_pro[index].index1;
      var index2 = this.inventory_pro[index].index2;
      var index3 = this.inventory_pro[index].index3;

      var adaptorloading = 0;

      if (mode == 0) {
        return (
          this.inventory_pro[index].list[index1].skus[index2].opt[index3]
            .base_price + adaptorloading
        ).toFixed(2);
      } else if (mode == 1) {
        return (
          this.inventory_pro[index].list[index1].skus[index2].opt[index3]
            .list_price + adaptorloading
        ).toFixed(2);
      }
    },
    getH3(item, i) {
      var str = item.list[item.index1].skus[item.index2].opt[item.index3].h3;
      var list = str.split("|");
      if (list.length > i) {
        return list[i].trim();
      } else {
        return "";
      }
    },
    getH4(item) {
      var str = item.list[item.index1].skus[item.index2].opt[item.index3].h3;
      if (str.toLowerCase().includes("skin bundle")) {
        return "Designed for both Pro and Classic trackers";
      }
      var list = str.split("|");
      if (list.length > 0) {
        //var first = list[0].split(" ")[0];
        return "Support all types of toothbrushes, manual or electric.";
      } else {
        return "Ready to use. App is free.";
      }
    },
    selectsku(a, b) {
      this.inventory[a].index = b;
    },
    selectsku1(item, index1, index2) {
      item.index1 = index1;
      item.index2 = index2;
    },
    calculateFinalPrice(p) {
      var new_p = p * (1 - store.state.discount_percent);
      return new_p.toFixed(2);
    },

    getCoupon() {
      //console.log("get:" + store.state.couponid);
      return store.state.couponid;
    },
    onAddCart2(item, index1, index2, index3) {
      var sku = {};
      var obj = item.list[index1].skus[index2].opt[index3];
      sku.id = obj.skuid;
      sku.image = obj.image;
      sku.metadata = {};
      sku.metadata.image0 = obj.image;
      sku.productname = item.list[index1].h2;

      sku.attributes = {};
      sku.attributes.Style = obj.h3;
      sku.price = obj.list_price * 100;
      var list = [];
      list.push({ sku: sku, quantity: 1 });

      if (this.adaptor == 1) {
        let adaptor_us = store.state.inventory.adaptor_us;
        adaptor_us.metadata = {};
        adaptor_us.metadata.image0 = adaptor_us.images[0];
        list.push({ sku: adaptor_us, quantity: 1 });
      } else if (this.adaptor == 2) {
        let adaptor_au = store.state.inventory.adaptor_au;
        adaptor_au.metadata = {};
        adaptor_au.metadata.image0 = adaptor_au.images[0];
        list.push({ sku: adaptor_au, quantity: 1 });
      }

      storage.onAddCart(list, this, true);
      /*
      this.stage = 1;
      var delayInMilliseconds = 400; //1 second

      setTimeout(function () {
        window.scrollTo(0, 0);
      }, delayInMilliseconds);
      */

     storage.reportInitCheckout(this.calculateFinalPrice(true, true));
      window.location.href = "/#/cart?state=1";

    },
    onAddCart() {
      var list = [];

      for (var i = 0; i < this.skinarray.length; i++) {
        if (this.skinarray[i] > 0) {
          var sku = this.getskinskulist()[i];
          sku.metadata = {};
          sku.metadata.image0 = sku.images[0];
          list.push({ sku: sku, quantity: 1 });
        }
      }
      storage.onAddCart(list, this, true);
      storage.reportInitCheckout(this.calculateFinalPrice(true, true));
      window.location.href = "/#/cart?state=1";
    },
    getdiscountedtotalprice(bundle, coupon) {
      return storage.calculateBundleDiscount(bundle, coupon);
    },
    shown() {},
  },
  mounted() {
    var context = this;
    //context.show = true;

    var stripekey = env.stripe_public_key;
    this.$loadScript(
      "https://js.stripe.com/v3/" // production
    ).then(() => {
      //console.log("stripe loaded");
      context.stripe = window.Stripe(stripekey, {
        apiVersion: "2020-08-27",
      });
    });

    this.$loadScript("https://www.paypalobjects.com/api/checkout.js").then(
      () => {}
    );

    storage.clearstorestate();
    this.skinarray = [];

    for (const key in store.state.inventory.skin) {
      let obj = store.state.inventory.skin[key];
      obj.productid = "prod_0000";
      store.state.skinskulist.push(obj);
      this.skinarray.push(0);
    }
    context.shuffleArray(store.state.skinskulist);

    //storage.populateSku(this, 1);
    storage.processCoupon();
    storage.saveCart2Store(this);
    this.stage = 0;
    var delayInMilliseconds = 400; //1 second

      setTimeout(function () {
        window.scrollTo(0, 0);
      }, delayInMilliseconds);
  },
};
</script>

<style lang="scss">
.activeskuskin {
  border: 3px solid #2ebfde !important;
  border-radius: 60px !important;
}

.inactiveskuskin {
  border: 3px solid transparent;
  border-radius: 60px !important;
  padding: 5%;
}

.swatch-thumbnail-t6 {
  width: 100%;
  max-width: 120px;
  padding: 10px;
}

.bundle-cell {
  max-width: 20%;
  padding-left: 0;
  padding-right: 10px;
}

.product-select-box {
  border-radius: 5px;
  border: 4px solid;
  border-color: #bdbdbd;
  background-color: white;
}
.product-select-box2 {
  border-radius: 5px;
  border: 4px solid;
  border-color: #fec131;
  background-color: white;
}

.bundle-h1 span,
.bundle-h1 {
  font-size: 30px;
  font-weight: 700;
}

.bundle-h2 span,
.bundle-h2 {
  font-size: 20px;
  font-weight: 700;
}

.modal-backdrop {
  opacity: 0.85 !important;
}
.tile-header {
  border-radius: 10px 10px 0 0;
  color: white;
  text-align: center;
  font-weight: 600;
}

.bundle-container {
  background-color: white;
  border-radius: 0 0 10px 10px;
  margin: 0 auto;
  max-width: 340px;
  padding-bottom: 30px;
}

.bundle-item-container {
  background-color: #f8f8f8;
  border-radius: 10px;
  margin-bottom: 6px;
  cursor: pointer;
  border: 2px solid;
  border-color: #f8f8f8;
  min-height: 55px !important;
}

.bundle-add-cart,
.bundle-add-cart:hover {
  background-color: white;
  color: #12b8ed;
  border-color: #12b8ed;
  padding-left: 20px;
  border: 2px solid;
  padding-right: 20px;
  font-weight: 600;
}

.subscription .selected-border {
  border: 3px solid !important;
  border-color: #12b8ed !important;
  border-radius: 10px;
}

.unselected-border {
  border: 2px solid;
  border-color: #dfe0e1;
  border-radius: 10px;
}

.bundle-item {
  padding-top: 5px;
  padding-bottom: 5px;
}

.accordion {
  border: 0px solid !important;
}
.accordion__title-text {
  font-size: 16px !important;
  text-align: left !important;
}

@media (max-width: 1199px) {
}
@media (min-width: 1200px) {
  .cart-nav-bundle {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
  }
}
@media only screen and (min-width: 1440px) {
  .cart-nav-bundle {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
  }
}

.image_bundle {
  padding: 5%;
}

@media (max-width: 768px) {
  .reduced-margin-top {
    margin-top: 30px !important;
  }
  .swatch-thumbnail-t6 {
    padding: 5px;
  }
  .accordion__toggle-button {
    text-align: left !important;
  }
  .accordion__title {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .accordion__title-text {
    font-size: 16px !important;
    text-align: left !important;
  }
  .pl_pr_0_sm {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .pl_pr_0_sm .faq {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
  .bundle-cell {
    max-width: 25%;
    padding-left: 2px;
    padding-right: 5px;
  }

  .max-width-sm {
    width: 100% !important;
  }

  .pl-pr-0-sm {
    padding-left: 0 !important;
  }
  .bundle-h1 span,
  .bundle-h1 {
    font-size: 26px;
    font-weight: 700;
  }

  .bundle-h2 span,
  .bundle-h2 {
    font-size: 16px;
    font-weight: 700;
  }

  .pl-pr-0-sm {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .image_bundle {
    padding: 0;
  }

  .bundle-item-container {
    max-width: 100%;
  }
}
</style> */